import React from 'react';
import './Loading.scss';

export const Loading: React.FC = () => (
  <div className="loading-container">
    <div className="loading-icon" />
    <div className="loading-message">Please wait...</div>
  </div>
);

export const LoadingFullScreen: React.FC = () => (
  <div className="loading-full-screen">
    <Loading />
  </div>
);
